import Map, {NavigationControl, Marker, Source, Layer}  from 'react-map-gl/mapbox';
import { useMemo, useEffect, useState, useRef } from 'react'
import './CMSMap.scss'
import 'mapbox-gl/dist/mapbox-gl.css';
import cmsIcon from '../../images/cmsMarker.png'
import useParksGeojson from '../../hooks/useParksGeojson';
import bbox from '@turf/bbox';
import slug from 'slug';
import useParksById from '../../hooks/useParksById';
// const MyCustomControl = (props) => {
//   const {current: map} = useMap();
//   // console.log(map)
//   // console.log(map.getMap())

//   // console.log(map.getMap().getCenter(), map.getMap().getZoom())
//   return (
//     null
//   )
// }

import { parksFillStyle, parksLineStyle } from '../../Map';

const californiaInitialViewState = {
  longitude: -121.778,
  latitude: 37.455,
  zoom: 4.5
}

export default function CMSMap(props) {
  const [moved, setMoved] = useState(0)
  const [mapLoaded, setMapLoaded] = useState(false)
  const mapRef = useRef()
  const { lat, lng, width, height, setLatLng, rerenderMap, park } = props
  const mapInitalized = useRef(-1)
  const [nonDefaultPitchOrRotation, setNonDefaultPitchOrRotation] = useState(false)
  const parksGeojson = useParksGeojson()
  const parks = useParksById()

  const parkFeature = useMemo(() => park && parksGeojson ? parksGeojson.features.find(f => slug(f.properties.name) === park) : null, [parksGeojson, park])
  const parkObject = parks[park]

  const parkBBox = useMemo(() => {
    if (!parkFeature) {
      return null
    }
    let box = parkFeature.properties.bbox || bbox(parkFeature)
    //expand the bounding box by a bit in each direction
    const offset = 0.01
    const expandedBox = [
      box[0] - offset ,
      box[1] - offset,
      box[2] + offset,
      box[3] + offset,
    ]

    return expandedBox
  }, [parkFeature])

  useEffect(() => {
    if (mapRef.current && mapLoaded && lat && lng && mapInitalized.current !== rerenderMap) {
      mapRef.current.getMap().flyTo({
        center: [lng, lat],
        zoom: 14
      })
      mapInitalized.current = rerenderMap
    } else if (mapRef.current && mapLoaded && parkBBox && !lat && !lng) {
      mapRef.current.fitBounds(parkBBox)
      mapInitalized.current = rerenderMap
    } else if (mapRef.current && mapLoaded && parkObject && parkObject.lat && parkObject.lng && !lat && !lng) {
      mapRef.current.getMap().flyTo({
        center: [parkObject.lng, parkObject.lat],
        zoom: 14
      })
      mapInitalized.current = rerenderMap
    }
  }, [lat, lng, mapLoaded, rerenderMap, parkBBox, parkObject])

  const updateLatLng = (e) => {
    setLatLng(e.lngLat)
  }
  const marker = lat && lng ?
    <Marker
      longitude={lng}
      latitude={lat}
      anchor="bottom"
      draggable={true}
      onDragEnd={updateLatLng}
      onDrag={updateLatLng}
    >
      <img src={cmsIcon} alt='' />
    </Marker>
    : null

  const doubleClick = e => {
    e.preventDefault()
    setLatLng(e.lngLat)
  }
  return (
    <div className='CMSMap'>
       <Map
        ref={mapRef}
        initialViewState={californiaInitialViewState}
        mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
        onError={(e) => console.error('CMS Mapbox error:', e)}
        onMoveEnd={() => setMoved(moved + 1)}
        style={{ width, height }}
        onLoad={() => setMapLoaded(true)}
        onPitch={() => setNonDefaultPitchOrRotation(true)}
        onRotation={() => setNonDefaultPitchOrRotation(true)}
        onDblClick={doubleClick}
        mapStyle="mapbox://styles/mapbox/streets-v12"

        // mapStyle="https://www.arcgis.com/sharing/rest/content/items/8eaddf4279684fc09abb2b61f1338be4/resources/styles/root.json?f=pjson"
        // transformRequest={(url) => {
        //   console.log(url)
        //   let finalURL = url
        //   if (url.startsWith('tile/')){
        //     finalURL = `https://server.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer/${url}`
        //   }
        //   return {
        //     url: finalURL
        //   }
        // }}
      >
        <NavigationControl showCompass={nonDefaultPitchOrRotation} key={nonDefaultPitchOrRotation} />
        {/* <MyCustomControl /> */}
        {marker}

        <Source id="parks" type="geojson" data={parksGeojson}>
          <Layer {...parksLineStyle} />
          <Layer {...parksFillStyle} />
        </Source>
      </Map>
    </div>
  )
}